(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["memio-inventory-shipping"] && !Shopify.designMode) return;
  try {
    // Horizon liefert beim Variantenwechsel das aktualisierte HTML über
  // event.promise -> { detail: { html, productId, newProduct } }.
  // Wie beim nativen <product-inventory> werden die von Liquid gerenderten
  // Werte übernommen – inklusive des Varianten-Metafelds custom.lieferzeit.
  if (!customElements.get('memio-inventory-shipping')) {
    customElements.define('memio-inventory-shipping', class extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;
        this._revision = 0;
        this._container = this.closest('.shopify-section, dialog') || this.parentElement;
        this._onProductSelect = this.handleProductSelect.bind(this);
        this._onVisibilityChange = this.handleVisibilityChange.bind(this);
        this._container?.addEventListener('shopify:product:select', this._onProductSelect);
        document.addEventListener('visibilitychange', this._onVisibilityChange);
        this.updateDeliveryDate();
      }

      disconnectedCallback() {
        this._revision += 1;
        this._container?.removeEventListener('shopify:product:select', this._onProductSelect);
        document.removeEventListener('visibilitychange', this._onVisibilityChange);
        this._initialized = false;
      }

      handleProductSelect(event) {
        // Dieselbe Filterung wie der native Horizon-Produktinventar-Block.
        if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
        if (!event.promise || typeof event.promise.then !== 'function') return;

        // WICHTIG: event.product ist keine garantierte Eigenschaft.
        // Die Produkt-ID wird erst nach Auflösen des Promises geprüft.
        const revision = ++this._revision;
        event.promise
          .then(({ detail }) => {
            if (!this.isConnected || revision !== this._revision || !detail?.html) return;

            const { html, newProduct } = detail;
            if (!newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) {
              return;
            }

            // Verwechslung vermeiden, wenn eine Sektion mehrere Memio-Blöcke hat.
            const allBlocks = Array.from(html.querySelectorAll('memio-inventory-shipping'));
            const next = allBlocks.find((node) => node.dataset.blockId === this.dataset.blockId)
              || (allBlocks.length === 1 ? allBlocks[0] : null);
            if (!next) return;

            if (!newProduct && next.dataset.productId && next.dataset.productId !== this.dataset.productId) {
              return;
            }
            this.syncFromRenderedVariant(next);
          })
          .catch((error) => {
            if (error?.name !== 'AbortError') {
              console.warn('[Memio Bestand & Versand] Variantenwechsel fehlgeschlagen:', error);
            }
          });
      }

      syncFromRenderedVariant(next) {
        // Wie morph(..., { childrenOnly: true }) beim Original:
        // Den Custom-Element-Host behalten, aber die Inhalte ersetzen.
        const existingContent = this.querySelector('.memio-inventory-shipping__inner');
        const nextContent = next.querySelector('.memio-inventory-shipping__inner');
        if (!existingContent || !nextContent) return;
        existingContent.replaceWith(nextContent.cloneNode(true));

        // Für Stock-Farbe, Neuberechnung und einfaches Debugging.
        for (const key of [
          'productId', 'selectedVariantId', 'inventoryState', 'currentDeliveryDays',
          'deliverySource', 'deliveryMode', 'includeWeekends', 'dateFormat', 'deliveryTimezone'
        ]) {
          if (key in next.dataset) this.dataset[key] = next.dataset[key];
        }
        this.updateDeliveryDate();
      }

      handleVisibilityChange() {
        // Wenn die Produktseite über Nacht offen bleibt, Datum aktualisieren.
        if (document.visibilityState === 'visible') this.updateDeliveryDate();
      }

      todayInShopTimezone() {
        const timeZone = this.dataset.deliveryTimezone || 'Europe/Berlin';
        let parts;
        try {
          parts = new Intl.DateTimeFormat('en-GB', {
            timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          }).formatToParts(new Date());
        } catch (error) {
          parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Europe/Berlin',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          }).formatToParts(new Date());
        }
        const get = (type) => Number(parts.find((part) => part.type === type)?.value);
        return new Date(Date.UTC(get('year'), get('month') - 1, get('day'), 12));
      }

      calculateDeliveryDate(days) {
        const date = this.todayInShopTimezone();
        const countWeekends = this.dataset.includeWeekends === 'true';
        let daysAdded = 0;
        while (daysAdded < days) {
          date.setUTCDate(date.getUTCDate() + 1);
          const weekday = date.getUTCDay();
          if (countWeekends || (weekday !== 0 && weekday !== 6)) daysAdded++;
        }
        return date;
      }

      formatDeliveryDate(date) {
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const year = date.getUTCFullYear();
        const months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
        const shortMonths = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];
        const weekdays = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
        const fullMonth = months[date.getUTCMonth()];
        const format = this.dataset.dateFormat;

        switch (format) {
          case '%d.%m.%Y': return `${day}.${month}.${year}`;
          case '%d/%m/%Y': return `${day}/${month}/${year}`;
          case '%B %d, %Y': return `${fullMonth} ${day}, ${year}`;
          case '%A, %d. %B': return `${weekdays[date.getUTCDay()]}, ${day}. ${fullMonth}`;
          case '%d. %b': return `${day}. ${shortMonths[date.getUTCMonth()]}`;
          default: return `${day}. ${fullMonth} ${year}`;
        }
      }

      updateDeliveryDate() {
        if (this.dataset.deliveryMode !== 'calculated_date') return;
        const dateElement = this.querySelector('[data-delivery-date]');
        if (!dateElement) return;
        const days = Number(this.dataset.currentDeliveryDays);
        if (!Number.isInteger(days) || days < 1 || days > 365) return;
        const newText = this.formatDeliveryDate(this.calculateDeliveryDate(days));
        if (dateElement.textContent !== newText) dateElement.textContent = newText;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["memio-quantity-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('memio-quantity-selector')) {
    customElements.define('memio-quantity-selector', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section') || this.parentElement;
        this.inputs = Array.from(this.querySelectorAll('input[type="radio"][data-memio-quantity]'));
        if (!this.inputs.length) return;

        const defaultQuantity = String(this.dataset.defaultQuantity || '1');
        const selected = this.inputs.find((input) => input.value === defaultQuantity) || this.inputs[0];
        selected.checked = true;

        this.inputs.forEach((input) => {
          input.addEventListener('change', () => this.sync());
        });

        this.submitHandler = () => this.syncForms();
        this.section.addEventListener('submit', this.submitHandler, true);

        this.observer = new MutationObserver(() => this.syncForms());
        this.observer.observe(this.section, { childList: true, subtree: true });
        this.sync();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.section && this.submitHandler) {
          this.section.removeEventListener('submit', this.submitHandler, true);
        }
      }

      get quantity() {
        const selected = this.inputs.find((input) => input.checked);
        return selected ? Math.max(1, parseInt(selected.value, 10) || 1) : 1;
      }

      sync() {
        this.inputs.forEach((input) => {
          input.closest('.memio-quantity-option')?.classList.toggle('is-selected', input.checked);
        });
        this.syncForms(true);
        this.dispatchEvent(new CustomEvent('memio:quantity-change', {
          bubbles: true,
          detail: { quantity: this.quantity }
        }));
      }

      syncForms(announceChange = false) {
        const forms = this.section.querySelectorAll('form[action*="/cart/add"]');
        forms.forEach((form) => {
          let input = form.querySelector('input[name="quantity"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'quantity';
            form.appendChild(input);
          }
          if (String(input.value) !== String(this.quantity)) {
            input.value = this.quantity;
            if (announceChange) input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
